import React from "react";
import { ToastContainer } from "react-toastify";

export default function CustomToastContainer() {
  return (
    <ToastContainer
      autoClose={5000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={true}
      bodyStyle={{ direction: "ltr" }}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
}
